// FLAGS: none
// Browser entry point: mounts the app into #root and pulls in the shared Tailwind bundle.
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "@src/App";

import "@openup/shared/tailwind.css";

const root = createRoot(document.getElementById("root") as HTMLElement);
root.render(
  <StrictMode>
    <App />
  </StrictMode>,
);
